export default __webpack_public_path__ + "static/media/iconCopyAddress.4fbf8679.svg";